module.exports = __webpack_public_path__ + "assets/account-inactive.b4a11e87.svg";